import React, {ReactNode, useRef} from "react";
import {useSize, useUpdateEffect} from "ahooks";
import styles from "./TabContent.module.css";
import poster from "../../image/poster.jpg";
import utils from "../../screens/utils";

export default function TabContent({
                                       children,
                                       recordHeight,
                                       index,
                                   }: {
    children: ReactNode;
    recordHeight: (height?: number) => void;
    index: number;
}) {
    const ref = useRef(null);
    const size = useSize(ref);

    useUpdateEffect(() => {
        recordHeight(size.height);
    }, [size.height]);

    return (
        <div ref={ref} id={`tabContent${index}`} className={styles.wrapper}>
            {children}
        </div>
    );
}


function Poster() {
    const getHeight = (): number => {
        const {innerHeight: height} = window;
        if (height < 600) {
            return 600
        }
        if (height > 1000) {
            return 1000
        }
        return height
    }

    return <div className={styles.poster} style={{
        backgroundImage: `url(${poster})`,
        height: getHeight() - 90
    }}>
        <div style={{
            color: "#1aad19",
            fontSize: "50px",
            fontWeight: 400,
        }}>矩阵世界
        </div>
        <div style={{
            color: "#1aad19",
            fontSize: "20px",
            fontWeight: 400,
            marginTop: "5px",
            marginBottom: "35px",
        }}>MATRIX WORLD
        </div>
        <div style={{
            color: "white",
            fontWeight: 400,
            fontSize: "4em",
        }}>以诚待人，以信立业
        </div>
    </div>;
}

function About() {
    const nowYear = utils.formatFromDate(new Date(), "yyyy");
    const beginYear = 2024;
    return (
        <div className={styles.main}>
            <div className={styles.titleContainer}>
                <div className={styles.title}>关于矩阵世界</div>
                <div className={styles.underline}/>
            </div>
            <div className={styles.aboutContentContainer}>
                <div className={styles.aboutContent}>
                    <div className={styles.itemText}>
                        厦门矩阵世界科技有限公司，成立于{beginYear}年，
                    </div>
                    <div className={styles.itemText}>
                        我公司为各行各业提供专业的IT技术服务，经过{Number(nowYear)-beginYear}年多的努力与发展，
                    </div>
                    <div className={styles.itemText}>
                        已具一定的规模及实力，现拥有一支技术精湛的IT服务团队，
                    </div>
                    <div className={styles.itemText}>
                        以卓越的服务品质、专业安全的技术服务实力，为不同群体的用户提供更高更优质的IT服务。
                    </div>
                </div>
            </div>
        </div>
    );
}

function ImageContent({
                          title,
                          height,
                          backgroundImage,
                      }: {
    title: string;
    height: number;
    backgroundImage: string;
}) {
    return (
        <div className={styles.main}>
            <div className={styles.titleContainer}>
                <div className={styles.title}>{title}</div>
                <div className={styles.underline}/>
            </div>
            <div
                className={styles.imageContent}
                style={{
                    height,
                    backgroundImage,
                }}
            />
        </div>
    );
}

function Contact() {
    const nowYear = utils.formatFromDate(new Date(), "yyyy");
    return (
        <div className={styles.contactContainer}>
            <div className={styles.main}>
                <div className={styles.titleContainer}>
                    <div className={styles.title}>联系我们</div>
                    <div className={styles.underline}/>
                </div>
                <div className={styles.contact}>
                    <div>电话：13515976551</div>
                </div>
            </div>
            <div className={styles.main}>
                <div className={styles.titleContainer}>
                    <div className={styles.title}>办公地点</div>
                    <div className={styles.underline}/>
                </div>
                <div className={styles.contact}>
                    <div>厦门市湖里区日圆二里2号423室</div>
                </div>
            </div>

            <div className={styles.main}>
                <div className={styles.beian}>
                    <div>
                        <a
                            href="http://beian.miit.gov.cn/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            闽ICP备2024071667号-1
                        </a>{" "}
                        <a
                            style={{
                                marginLeft: 5,
                            }}
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602003162"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            闽公网安备35020602003162号
                        </a>{" "}
                        |
                        © 2024 - {nowYear} 厦门矩阵世界科技有限公司
                    </div>
                </div>
            </div>
        </div>
    );
}

export {Poster, About, ImageContent, Contact};
